﻿const INCREMENT_TO_CURRENT_STEP = 1;
const NO_RESULT_FOUND_VALUE = -1;

export const getCurrentStepIndex = (approvalSteps, lastCompletedStepId) => {
  if (!approvalSteps?.length || !lastCompletedStepId) return;

  const lastCompletedStepIndex = approvalSteps.findIndex(
    ({ id }) => id === lastCompletedStepId
  );

  if (lastCompletedStepIndex === NO_RESULT_FOUND_VALUE) return;

  return lastCompletedStepIndex + INCREMENT_TO_CURRENT_STEP;
};
